import styles from './ItemDetail.css'
import ItemForm from './ItemForm'
import {
  clearAmountField,
  submitFormCreate,
  submitFormUpdate
} from 'actions/library/item'
import {connect} from 'react-redux'
import {getFormValues} from 'redux-form'

class ItemDetail extends React.Component {
  render () {
    return (<div className={styles.wrapper}>
      <div className={styles.form}>
        <ItemForm
          onSubmit={this._onSubmit}
          onChangeSwitch={this._onChangeSwitch}
        />
      </div>
    </div>)
  }
  _onChangeSwitch = () => {
    this.props.dispatch(clearAmountField())
  }

  _onSubmit = (values) => {
    const {dispatch, items, search} = this.props
    // add modifier ids value and remove active_modifiers for the api
    values.modifier_ids = values.active_modifiers.map((am) => { return am.id })

    // update updated at
    // kode ini ngikut yang di moka-rails aja, di https://github.com/mokapos/moka-rails/blob/306f092dce63619cf18ab7385006f4836045159f/app/assets/javascripts/moka/services/api.js#L1003

    // we must delete the 'action' property so it doesn't sent to server.
    let allOutlet = values.action !== 'save'
    delete values.action

    // we must delete the in_stock value to prevent overwriting the data
    values.item_variants.forEach((iv) => {
      if (!iv.is_editable) {
        delete iv.in_stock
      }
    })

    // if it is create, the api wants 'remote_image_url' to be sent
    if (!values.id) {
      if (values.image && values.image.url) {
        values.remote_image_url = values.image.url
      } else {
        values.remote_image_url = ''
      }
    }

    if (values.id) {
      dispatch(submitFormUpdate(values.id, {item: values}, allOutlet, items))
    } else {
      // ini nambahin juga, kelupaan, emang harusnya nambahin pas create seperti di moka-rails
      // kode ini ngikut yang dev aja, di https://github.com/mokapos/moka-rails/blob/306f092dce63619cf18ab7385006f4836045159f/app/assets/javascripts/moka/services/api.js#L985
      dispatch(submitFormCreate({item: values}, allOutlet, items, search))
    }
  }
}

function mapStateToProps (state) {
  const {items, itemDetail} = state.library.item
  return {
    items,
    itemDetail,
    search: getFormValues('search')(state)
  }
}

ItemDetail.propTypes = {
  Item: React.PropTypes.object,
  dispatch: React.PropTypes.func
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemDetail)



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemDetail.js